// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consulting {
  position: relative;
  width: 100%;
  padding: 24px 0 0;
  margin-bottom: 56px;
}
.consulting .more-planning {
  text-align: center;
  margin-bottom: 30px;
}
.consulting .more-planning button {
  color: var(--sebrae-blue-7);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
}
.consulting .list-planning {
  position: relative;
}
.consulting .list-planning .wrapper-loading-small {
  height: 100%;
}
.consulting .list-planning .empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  font-size: 13px;
  color: var(--sebrae-gray);
  padding: 50px 0;
}
.consulting .buttons-tab {
  margin: 24px 0;
  width: 100%;
  max-width: 600px;
  display: flex;
  align-items: center;
}
.consulting .buttons-tab__button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 8px 16px;
  border: 1px solid var(--sebrae-blue-6);
  background-color: var(--sebrae-white);
  font-size: 14px;
  color: var(--sebrae-gray);
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.consulting .buttons-tab__button:first-of-type {
  border-radius: 4px 0 0 4px;
}
.consulting .buttons-tab__button:last-of-type {
  border-radius: 0 4px 4px 0;
}
.consulting .buttons-tab__button.active {
  background-color: var(--sebrae-blue-6);
  color: var(--sebrae-white);
}
@media screen and (min-width: 768px) {
  .consulting .buttons-tab__button {
    font-size: 16px;
    height: 40px;
  }
}
@media screen and (min-width: 768px) {
  .consulting .page-plannings-structure__filters .BaSe--select {
    width: 160px;
  }
}
@media screen and (min-width: 1024px) {
  .consulting .page-plannings-structure__filters .BaSe--select {
    width: 235px;
  }
}
@media screen and (min-width: 1280px) {
  .consulting .card-status-wrapper {
    max-width: 420px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/consulting/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;EACA,mBAAA;AACJ;AACI;EACE,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AACN;AAEE;EACE,kBAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAAN;AAGE;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,sCAAA;EACA,qCAAA;EACA,eAAA;EACA,yBAAA;EACA,kDAAA;AADN;AAGM;EACE,0BAAA;AADR;AAGM;EACE,0BAAA;AADR;AAGM;EACE,sCAAA;EACA,0BAAA;AADR;AAIM;EAxBF;IAyBI,eAAA;IACA,YAAA;EADN;AACF;AAKE;EACE;IACE,YAAA;EAHJ;AACF;AAKE;EACE;IACE,YAAA;EAHJ;AACF;AAKE;EACE;IACE,gBAAA;EAHJ;AACF","sourcesContent":[".consulting {\n  position: relative;\n  width: 100%;\n  padding: 24px 0 0;\n  margin-bottom: 56px;\n\n  .more-planning {\n    text-align: center;\n    margin-bottom: 30px;\n\n    button {\n      color: var(--sebrae-blue-7);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n  }\n  .list-planning {\n    position: relative;\n\n    .wrapper-loading-small {\n      height: 100%;\n    }\n    .empty {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 15px;\n      font-size: 13px;\n      color: var(--sebrae-gray);\n      padding: 50px 0;\n    }\n  }\n  .buttons-tab {\n    margin: 24px 0;\n    width: 100%;\n    max-width: 600px;\n    display: flex;\n    align-items: center;\n\n    &__button {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 32px;\n      padding: 8px 16px;\n      border: 1px solid var(--sebrae-blue-6);\n      background-color: var(--sebrae-white);\n      font-size: 14px;\n      color: var(--sebrae-gray);\n      transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n      &:first-of-type {\n        border-radius: 4px 0 0 4px;\n      }\n      &:last-of-type {\n        border-radius: 0 4px 4px 0;\n      }\n      &.active {\n        background-color: var(--sebrae-blue-6);\n        color: var(--sebrae-white);\n      }\n\n      @media screen and (min-width: 768px) {\n        font-size: 16px;\n        height: 40px;\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .page-plannings-structure__filters .BaSe--select {\n      width: 160px;\n    }\n  }\n  @media screen and (min-width: 1024px) {\n    .page-plannings-structure__filters .BaSe--select {\n      width: 235px;\n    }\n  }\n  @media screen and (min-width: 1280px) {\n    .card-status-wrapper {\n      max-width: 420px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
